interface ClientsTableProps {
  onSelectClient: (clientId: string) => void;
}

export default function ClientsTable({ onSelectClient }: ClientsTableProps) {
  const clients = [
    { id: "CLI-001", name: "Importadora del Norte S.A.", rfc: "IDN850623AB1", type: "Importador", status: "Activo", operations: 45, executive: "María González", lastOp: "2024-01-15" },
    { id: "CLI-002", name: "Exportaciones Globales", rfc: "EXG920415CD2", type: "Exportador", status: "Activo", operations: 38, executive: "Carlos Ruiz", lastOp: "2024-01-14" },
    { id: "CLI-003", name: "Comercializadora Internacional", rfc: "CIN780920EF3", type: "Ambos", status: "Activo", operations: 62, executive: "Ana Martínez", lastOp: "2024-01-16" },
    { id: "CLI-004", name: "Logística y Comercio S.C.", rfc: "LYC030512GH4", type: "Importador", status: "Activo", operations: 28, executive: "María González", lastOp: "2024-01-13" },
    { id: "CLI-005", name: "Distribuidora Nacional", rfc: "DIN950807IJ5", type: "Importador", status: "Inactivo", operations: 15, executive: "Carlos Ruiz", lastOp: "2023-12-20" },
    { id: "CLI-006", name: "Productos del Pacífico", rfc: "PDP880225KL6", type: "Exportador", status: "Activo", operations: 41, executive: "Ana Martínez", lastOp: "2024-01-15" },
    { id: "CLI-007", name: "Tecnología y Comercio", rfc: "TYC010918MN7", type: "Ambos", status: "Activo", operations: 53, executive: "María González", lastOp: "2024-01-16" },
    { id: "CLI-008", name: "Alimentos Internacionales", rfc: "AIN930604OP8", type: "Importador", status: "Prospecto", operations: 2, executive: "Carlos Ruiz", lastOp: "2024-01-10" },
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Activo": return "bg-[#10B981]/10 text-[#10B981]";
      case "Inactivo": return "bg-gray-100 text-gray-600";
      case "Prospecto": return "bg-[#EAB308]/10 text-[#EAB308]";
      default: return "bg-gray-100 text-gray-600";
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-[#EAF2F8] border-b border-gray-200">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Cliente</th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">RFC</th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Tipo</th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Estado</th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Operaciones</th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Ejecutivo</th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Última Op.</th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Acciones</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {clients.map((client) => (
              <tr key={client.id} className="hover:bg-gray-50 transition-colors cursor-pointer" onClick={() => onSelectClient(client.id)}>
                <td className="px-6 py-4">
                  <div>
                    <p className="text-sm font-semibold text-[#0A2A43]">{client.name}</p>
                    <p className="text-xs text-gray-500">{client.id}</p>
                  </div>
                </td>
                <td className="px-6 py-4 text-sm text-gray-600">{client.rfc}</td>
                <td className="px-6 py-4 text-sm text-gray-600">{client.type}</td>
                <td className="px-6 py-4">
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${getStatusColor(client.status)}`}>
                    {client.status}
                  </span>
                </td>
                <td className="px-6 py-4 text-sm font-semibold text-[#2F80ED]">{client.operations}</td>
                <td className="px-6 py-4 text-sm text-gray-600">{client.executive}</td>
                <td className="px-6 py-4 text-sm text-gray-600">{client.lastOp}</td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-2">
                    <button className="w-8 h-8 flex items-center justify-center text-[#2F80ED] hover:bg-[#EAF2F8] rounded-md transition-colors">
                      <i className="ri-eye-line"></i>
                    </button>
                    <button className="w-8 h-8 flex items-center justify-center text-[#114B7A] hover:bg-[#EAF2F8] rounded-md transition-colors">
                      <i className="ri-edit-line"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
